// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3taOX","label":"Section_label__1Of3Z","contentWrap":"Section_contentWrap__2KouA","footer":"Section_footer__gY74G","footerInner":"Section_footerInner__3N9wC"};